<template>
  <div class="view view--programs">
    <data-table
      class="has-margin-b45"
      v-bind:data="tableData"
      v-on:sort="sortDataTable"
    ></data-table>

    <modal
      class="is-narrow"
      v-bind:title="__('Are you sure?')"
      v-bind:is-open="isOpenDeleteModal"
      v-on:close-modal="isOpenDeleteModal = false"
    >
      <template v-slot:body>
        <p
          class="has-text-center"
          v-html="
                        __(
                            'Are you sure you want to delete this organizer?<br />This action cannot be undone.'
                        )
                    "
        ></p>
      </template>
      <template v-slot:footer>
        <div class="has-padding-t10">
          <div class="columns">
            <div class="column">
              <btn
                class="is-block"
                type="cancel"
                v-html="__('Cancel')"
                v-on:click="isOpenDeleteModal = false"
              >
              </btn>
            </div>
            <div class="column">
              <btn
                class="is-block"
                type="error"
                v-html="__('Delete')"
                v-on:click="deleteOrganizer"
              >
              </btn>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import MessageHandler from '../../messageHandler';
import store from '../../store';

import { Btn } from '@teamfurther/cinderblock';
import { DataTable } from '@teamfurther/cinderblock';
import { Modal } from '@teamfurther/cinderblock';
import OrganizerRepository from "../../repositories/OrganizerRepository";

export default {
  components: {
    Btn,
    DataTable,
    Modal
  },
  created: function() {
    this.organizerRepository = new OrganizerRepository();
  },
  data: function() {
    return {
      deletingId: null,
      errors: {},
      isOpenDeleteModal: false,
      organizerRepository: null,
      organizers: [],
      tableData: {
        columnNames: {
          title: this.__('Title'),
          address: this.__('Address'),
          email: this.__('Email'),
          registrationNumber: this.__('Registration number'),
          status: this.__('Status')
        },
        items: [],
        sortableColumns: ['title', 'address', 'email', 'status']
      }
    };
  },
  methods: {
    deleteOrganizer: async function() {
      try {
        await this.organizerRepository.deleteOrganizer(this.deletingId);

        store.state.alerts.push(
          new MessageHandler(
            this.__('Organizer was successfully deleted.'),
            this.__('Success.'),
            'success'
          )
        );

        await this.getOrganizers('');
      } catch (error) {
      } finally {
        this.isOpenDeleteModal = false;
      }
    },
    getOrganizers: async function(sort = '') {
      try {
        this.organizers = await this.organizerRepository.getOrganizers(sort);

        let items = [];
        this.organizers.forEach(organizer => {
          items.push(this.transformOrganizerData(organizer));
        });

        this.$set(this.tableData, 'items', items);
      } catch (error) {}
    },
    showDeleteModal: function(data) {
      this.deletingId = data.id;
      this.isOpenDeleteModal = true;
    },
    transformOrganizerData: function(organizer) {
      let actions = [];

      actions.push({
        class: 'is-red',
        method: 'showDeleteModal',
        title: this.__('Delete')
      });
      actions.push({
        title: this.__('Edit'),
        url: '/admin#/organizers/' + organizer.id + '/edit'
      });

      return {
        values: {
          id: organizer.id,
          title: organizer.title,
          address: organizer.address,
          email: organizer.email,
          registrationNumber: organizer.registration_number,
          status: organizer.status,
        },
        actions: actions
      };
    },
    sortDataTable: function(sortByColumn) {
      if (
        this.tableData.sortableColumns.includes(
          sortByColumn.replace('-', '')
        )
      ) {
        this.getOrganizers(sortByColumn);
      }
    }
  },
  mounted: function() {
    this.getOrganizers();
  }
};
</script>
